import React, { useCallback } from 'react';
import PropTypes from 'prop-types';

// Utils
import { useTranslation } from 'react-i18next';

// Components
import InputField from '../../../../../atoms/InputField/InputField';
import WysiwygTextarea from '../../../../../molecules/WysiwygTextarea/WysiwygTextarea';
import FlashMessage from '../../../../../molecules/FlashMessage/FlashMessage';

function Translations({
  productType, formik, initialValues, warningMessage,
}) {
  const { t } = useTranslation();

  const getInput = useCallback((name) => (
    <div className="m-b-15">
      <InputField
        id={`${productType}_translations_${name}`}
        name={name}
        value={formik.values[name]}
        label={t(`${productType}.translations.form.${name}`)}
        formik={{
          handleChange: formik.handleChange,
          handleBlur: formik.handleBlur,
        }}
        error={formik.errors?.[name] && formik.touched?.[name] ? formik.errors[name] : null}
        isRequired
        full
      />
    </div>
  ), [formik]);

  return (
    <>
      {warningMessage ? (
        <div className="d-flex m-b-20">
          <FlashMessage color="warning" message={warningMessage} />
        </div>
      ) : null}

      <div className="input_max">
        {getInput('title')}
      </div>

      <div className="m-t-40">
        <h3 className="fs-20 m-b-25">
          {t(`${productType}.translations.form.description`)}
          <span className="c-primary-500 m-l-5 fs-18">*</span>
        </h3>

        <WysiwygTextarea
          name="description"
          onChange={(value) => formik.setFieldValue('description', value)}
          rawValue={initialValues?.description}
          placeholder={t(`${productType}.translations.form.description`)}
          error={formik.errors?.description && formik.touched?.description ? formik.errors.description : null}
          formik={{
            setFieldTouched: formik.setFieldTouched,
          }}
        />
      </div>
    </>
  );
}

Translations.propTypes = {
  formik: PropTypes.shape({
    values: PropTypes.shape({
      isNovelty: PropTypes.bool,
      name: PropTypes.string,
      sport: PropTypes.shape({}),
      type: PropTypes.shape({}),
    }),
    handleChange: PropTypes.func,
    handleBlur: PropTypes.func,
    setFieldValue: PropTypes.func,
    setFieldTouched: PropTypes.func,
    errors: PropTypes.shape({
      description: PropTypes.string,
    }),
    touched: PropTypes.shape({
      description: PropTypes.bool,
    }),
  }).isRequired,
  initialValues: PropTypes.shape({
    description: PropTypes.node,
  }),
  warningMessage: PropTypes.string,
  productType: PropTypes.string.isRequired,
};

Translations.defaultProps = {
  initialValues: null,
  warningMessage: null,
};

export default Translations;
